// 2P AI — barra di navigazione in basso (mobile-first). Progetti / Server / Notifiche (con badge).
import { Icon } from './Icon';

export type NavKey = 'progetti' | 'server' | 'notifiche';

const ITEMS: { key: NavKey; icon: string; label: string }[] = [
  { key: 'progetti', icon: 'folder_open', label: 'Progetti' },
  { key: 'server', icon: 'dns', label: 'Server' },
  { key: 'notifiche', icon: 'notifications', label: 'Notifiche' },
];

export function BottomNav({ active, onNavigate, badge = 0 }: { active: NavKey; onNavigate: (k: NavKey) => void; badge?: number }) {
  return (
    <nav className="bottomnav" role="tablist" aria-label="Navigazione principale">
      <div className="inner">
        {ITEMS.map((it) => (
          <button
            key={it.key}
            className="navitem"
            role="tab"
            type="button"
            aria-current={active === it.key ? 'true' : 'false'}
            onClick={() => onNavigate(it.key)}
          >
            <Icon name={it.icon} />
            {it.key === 'notifiche' && badge > 0 ? <span className="nbadge">{badge}</span> : null}
            <span className="lab">{it.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
